import { useEffect, useRef, useState } from "react";

/**
 * Animated numeric counter triggered when it scrolls into view.
 */
export const Counter = ({
    to,
    prefix = "",
    suffix = "",
    decimals = 0,
    duration = 1800,
    customDisplay = null,
    className = "",
    testId,
}) => {
    const [value, setValue] = useState(0);
    const ref = useRef(null);
    const started = useRef(false);

    useEffect(() => {
        if (customDisplay) return;
        const node = ref.current;
        if (!node) return;

        const io = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting && !started.current) {
                        started.current = true;
                        const start = performance.now();
                        const tick = (now) => {
                            const p = Math.min(1, (now - start) / duration);
                            const eased = 1 - Math.pow(1 - p, 3);
                            setValue(to * eased);
                            if (p < 1) requestAnimationFrame(tick);
                            else setValue(to);
                        };
                        requestAnimationFrame(tick);
                    }
                });
            },
            { threshold: 0.4 },
        );
        io.observe(node);
        return () => io.disconnect();
    }, [to, duration, customDisplay]);

    const display = customDisplay
        ? customDisplay
        : `${prefix}${value.toLocaleString(undefined, {
              minimumFractionDigits: decimals,
              maximumFractionDigits: decimals,
          })}${suffix}`;

    return (
        <span
            ref={ref}
            data-testid={testId}
            className={`tab-nums ${className}`}
        >
            {display}
        </span>
    );
};
